// function initMap() {
//   const centerMap = { lat: 45.559, lng: -73.712 };
//   const mapOptions = {
//     center: centerMap,
//     zoom: 10,
//     disableDefaultUI: true,
//     styles: [
//       {
//         elementType: "geometry",
//         stylers: [
//           {
//             color: "#212121",
//           },
//         ],
//       },
//       {
//         elementType: "labels.icon",
//         stylers: [
//           {
//             visibility: "off",
//           },
//         ],
//       },
//       {
//         elementType: "labels.text.fill",
//         stylers: [
//           {
//             color: "#757575",
//           },
//         ],
//       },
//       {
//         elementType: "labels.text.stroke",
//         stylers: [
//           {
//             color: "#212121",
//           },
//         ],
//       },
//       {
//         featureType: "administrative",
//         elementType: "geometry",
//         stylers: [
//           {
//             color: "#757575",
//           },
//         ],
//       },
//       {
//         featureType: "administrative.country",
//         elementType: "labels.text.fill",
//         stylers: [
//           {
//             color: "#9e9e9e",
//           },
//         ],
//       },
//       {
//         featureType: "administrative.land_parcel",
//         stylers: [
//           {
//             visibility: "off",
//           },
//         ],
//       },
//       {
//         featureType: "administrative.locality",
//         elementType: "labels.text.fill",
//         stylers: [
//           {
//             color: "#bdbdbd",
//           },
//         ],
//       },
//       {
//         featureType: "poi",
//         elementType: "labels.text.fill",
//         stylers: [
//           {
//             color: "#757575",
//           },
//         ],
//       },
//       {
//         featureType: "poi.park",
//         elementType: "geometry",
//         stylers: [
//           {
//             color: "#181818",
//           },
//         ],
//       },
//       {
//         featureType: "poi.park",
//         elementType: "labels.text.fill",
//         stylers: [
//           {
//             color: "#616161",
//           },
//         ],
//       },
//       {
//         featureType: "poi.park",
//         elementType: "labels.text.stroke",
//         stylers: [
//           {
//             color: "#1b1b1b",
//           },
//         ],
//       },
//       {
//         featureType: "road",
//         elementType: "geometry.fill",
//         stylers: [
//           {
//             color: "#2c2c2c",
//           },
//         ],
//       },
//       {
//         featureType: "road",
//         elementType: "labels.text.fill",
//         stylers: [
//           {
//             color: "#8a8a8a",
//           },
//         ],
//       },
//       {
//         featureType: "road.arterial",
//         elementType: "geometry",
//         stylers: [
//           {
//             color: "#373737",
//           },
//         ],
//       },
//       {
//         featureType: "road.highway",
//         elementType: "geometry",
//         stylers: [
//           {
//             color: "#3c3c3c",
//           },
//         ],
//       },
//       {
//         featureType: "road.highway.controlled_access",
//         elementType: "geometry",
//         stylers: [
//           {
//             color: "#4e4e4e",
//           },
//         ],
//       },
//       {
//         featureType: "road.local",
//         elementType: "labels.text.fill",
//         stylers: [
//           {
//             color: "#616161",
//           },
//         ],
//       },
//       {
//         featureType: "transit",
//         elementType: "labels.text.fill",
//         stylers: [
//           {
//             color: "#757575",
//           },
//         ],
//       },
//       {
//         featureType: "water",
//         elementType: "geometry",
//         stylers: [
//           {
//             color: "#000000",
//           },
//         ],
//       },
//       {
//         featureType: "water",
//         elementType: "labels.text.fill",
//         stylers: [
//           {
//             color: "#3d3d3d",
//           },
//         ],
//       },
//     ],
//   };
//   const map = new google.maps.Map(
//     document.getElementById("google-map"),
//     mapOptions
//   );
// }

function initMap() {
  const centerMap = { lat: 45.497, lng: -73.564 };
  const mapStyle = [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#0e2a47",
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#f4f7fa",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          saturation: 0,
        },
        {
          lightness: 45,
        },
        {
          color: "#c0d1e3",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#8CCEFF",
        },
        {
          visibility: "on",
        },
      ],
    },
  ];
  //[
  //   {
  //     elementType: "geometry",
  //     stylers: [
  //       {
  //         color: "#212121",
  //       },
  //     ],
  //   },
  //   {
  //     elementType: "labels.icon",
  //     stylers: [
  //       {
  //         visibility: "off",
  //       },
  //     ],
  //   },
  //   {
  //     elementType: "labels.text.fill",
  //     stylers: [
  //       {
  //         color: "#757575",
  //       },
  //     ],
  //   },
  //   {
  //     elementType: "labels.text.stroke",
  //     stylers: [
  //       {
  //         color: "#212121",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "administrative",
  //     elementType: "geometry",
  //     stylers: [
  //       {
  //         color: "#757575",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "administrative.country",
  //     elementType: "labels.text.fill",
  //     stylers: [
  //       {
  //         color: "#9e9e9e",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "administrative.land_parcel",
  //     stylers: [
  //       {
  //         visibility: "off",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "administrative.locality",
  //     elementType: "labels.text.fill",
  //     stylers: [
  //       {
  //         color: "#bdbdbd",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "poi",
  //     elementType: "labels.text.fill",
  //     stylers: [
  //       {
  //         color: "#757575",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "poi.park",
  //     elementType: "geometry",
  //     stylers: [
  //       {
  //         color: "#181818",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "poi.park",
  //     elementType: "labels.text.fill",
  //     stylers: [
  //       {
  //         color: "#616161",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "poi.park",
  //     elementType: "labels.text.stroke",
  //     stylers: [
  //       {
  //         color: "#1b1b1b",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "road",
  //     elementType: "geometry.fill",
  //     stylers: [
  //       {
  //         color: "#2c2c2c",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "road",
  //     elementType: "labels.text.fill",
  //     stylers: [
  //       {
  //         color: "#8a8a8a",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "road.arterial",
  //     elementType: "geometry",
  //     stylers: [
  //       {
  //         color: "#373737",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "road.highway",
  //     elementType: "geometry",
  //     stylers: [
  //       {
  //         color: "#3c3c3c",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "road.highway.controlled_access",
  //     elementType: "geometry",
  //     stylers: [
  //       {
  //         color: "#4e4e4e",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "road.local",
  //     elementType: "labels.text.fill",
  //     stylers: [
  //       {
  //         color: "#616161",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "transit",
  //     elementType: "labels.text.fill",
  //     stylers: [
  //       {
  //         color: "#757575",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "water",
  //     elementType: "geometry",
  //     stylers: [
  //       {
  //         color: "#000000",
  //       },
  //     ],
  //   },
  //   {
  //     featureType: "water",
  //     elementType: "labels.text.fill",
  //     stylers: [
  //       {
  //         color: "#3d3d3d",
  //       },
  //     ],
  //   },
  // ];

  const map = new google.maps.Map(document.getElementById("map"), {
    center: centerMap, // Set map center
    disableDefaultUI: true,
    zoom: 16,
    styles: mapStyle, // Apply custom styles
  });
}

window.onload = initMap;
